import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import routes from "routes.js";
const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [allowedRoutesFromApi, setAllowedRoutesFromApi] = useState([]);
  console.log(allowedRoutesFromApi, "allowedRoutesFromApi");
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  console.log(filteredRoutes , "filteredRoutesfilteredRoutes");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  console.log(isAuthenticated , "isAuthenticated");
    const [permissions, setPermissions] = useState([]);

  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      setLoading(true);
      
      axios
        .get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getAllMenus`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.result.success) {
            console.log(response.data.result.menus , "AbhayPratap");
            setIsAuthenticated(true);
            const filteredMenus = response.data.result.menus.filter(
              (menu) => menu.permissions.view
            );
            const allowedRoutes = filteredMenus.map((menu) => menu.route);
            setAllowedRoutesFromApi(allowedRoutes);
            setPermissions(response.data.result.menus);
          }
          
        })
        .catch((error) => {setIsAuthenticated(false);console.error("Error fetching menu data:", error)})
        .finally(() => {
          setLoading(false); 
        });
    } else {
      setIsAuthenticated(false);
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    
    if (allowedRoutesFromApi.length > 0) {
      const filtered = routes.filter(
        (route) =>
          allowedRoutesFromApi.includes(route.path) ||
          (route.permissionKey &&
            allowedRoutesFromApi.includes(route.permissionKey))
      );
      setFilteredRoutes(filtered);
    }
  }, [allowedRoutesFromApi]);
 

  return (
    <AuthContext.Provider value={{ loading, filteredRoutes, isAuthenticated: isAuthenticated ,permissions  }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
